<template>
  <div class="bg-gray-50">
    <div class="space-y-4">
      <!-- 搜索区域 -->
      <div class="bg-white rounded-lg border border-gray-200 shadow-sm">
        <div class="p-4">
          <div class="flex flex-col gap-4">
            <!-- 搜索框和筛选行 -->
            <div class="flex flex-col lg:flex-row gap-4">
            <!-- 搜索框 -->
            <div class="flex-1">
              <div class="relative">
                <input
                  v-model="searchQuery"
                  type="text"
                  placeholder="搜索产品名称、编号..."
                  class="w-full h-10 pl-10 pr-4 text-sm bg-gray-50/50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 focus:bg-white transition-all duration-200 placeholder-gray-400"
                  @keyup.enter="handleSearch"
                >
                <MagnifyingGlassIcon class="absolute left-3 top-2.5 h-5 w-5 text-gray-400" />
              </div>
              </div>

              <!-- 筛选选项 -->
              <div class="grid grid-cols-2 sm:flex sm:flex-row gap-2">
                <!-- 分组筛选 -->
                <div class="sm:w-56 sm:flex-initial">
                  <SearchableSelect
                    v-model="selectedGroup"
                    :options="groupOptions"
                    placeholder="全部分组"
                    label-key="name"
                    value-key="id"
                    @update:modelValue="handleSearch"
                  />
                </div>

                <!-- 品牌筛选 -->
                <div class="sm:w-56 sm:flex-initial">
                  <SearchableSelect
                    v-model="selectedBrand"
                    :options="brandOptions"
                    placeholder="全部品牌"
                    label-key="name"
                    value-key="id"
                    @update:modelValue="handleSearch"
                  />
            </div>
          </div>
            <!-- 搜索和添加按钮 -->
             <div>
            <div class="grid grid-cols-2 gap-2 sm:flex sm:gap-2">
              <button
                @click="handleSearch"
                :disabled="loading"
                class="inline-flex items-center justify-center h-10 px-4 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 hover:border-blue-300 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <MagnifyingGlassIcon class="h-4 w-4 mr-2" />
                搜索产品
              </button>
              <button
                @click="handleAddProduct"
                class="inline-flex items-center justify-center h-10 px-4 text-sm font-medium text-white bg-gradient-to-r from-blue-600 to-blue-700 rounded-lg hover:from-blue-700 hover:to-blue-800 focus:ring-2 focus:ring-blue-500/20 focus:ring-offset-2 shadow-sm hover:shadow-md transform hover:scale-105 transition-all duration-200"
              >
                <PlusIcon class="h-4 w-4 mr-2" />
                添加产品
              </button>
            </div>
              </div>
            </div>

            <!-- 第二行：管理按钮 -->
            <div class="grid grid-cols-2 sm:flex sm:flex-wrap gap-2">
              <button
                @click="handleManageGroups"
                class="inline-flex items-center justify-center h-10 px-3 sm:px-4 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200"
              >
                <svg class="h-4 w-4 mr-1 sm:mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
                分组管理
              </button>
              <button
                v-if="canManageCustomFields"
                @click="handleManageCustomFields"
                class="inline-flex items-center justify-center h-10 px-3 sm:px-4 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200"
              >
                <svg class="h-4 w-4 mr-1 sm:mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                自定义字段
              </button>
              <button
                @click="handleFieldConfig"
                class="inline-flex items-center justify-center h-10 px-3 sm:px-4 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 focus:ring-2 focus:ring-blue-500/20 transition-all duration-200 col-span-2 sm:col-span-1"
              >
                <svg class="h-4 w-4 mr-1 sm:mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
                </svg>
                字段配置
              </button>
            </div>
          </div>
        </div>
      </div>


      <!-- 产品列表 -->
      <div class="bg-white rounded-lg border border-gray-200 shadow-sm">
        <div v-if="loading" class="flex items-center justify-center py-20">
          <div class="text-center">
            <svg class="animate-spin h-8 w-8 text-blue-600 mx-auto mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <p class="text-gray-600 text-lg">加载中...</p>
          </div>
        </div>

        <div v-else-if="!loading && products.length === 0" class="flex items-center justify-center py-20">
          <div class="text-center text-gray-500">
            <svg class="mx-auto h-12 w-12 text-gray-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
            <p class="text-lg font-medium mb-2">
              {{ searchQuery ? '未找到相关产品' : '暂无产品' }}
            </p>
            <p class="text-sm">
              {{ searchQuery ? '尝试使用其他关键词搜索' : '点击上方"添加产品"按钮创建第一个产品' }}
            </p>
            <button
              v-if="searchQuery"
              @click="searchQuery = ''; handleSearch()"
              class="mt-3 inline-flex items-center px-3 py-1.5 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors"
            >
              清空搜索条件
            </button>
          </div>
        </div>

        <!-- API错误状态 -->
        <div v-else-if="!loading && apiError" class="flex items-center justify-center py-20">
          <div class="text-center text-red-500">
            <svg class="mx-auto h-12 w-12 text-red-400 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p class="text-lg font-medium mb-2">加载失败</p>
            <p class="text-sm mb-4">{{ apiError }}</p>
            <button
              @click="searchProducts(false)"
              class="inline-flex items-center px-3 py-1.5 text-sm font-medium text-blue-600 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors"
            >
              重试
            </button>
          </div>
        </div>

        <!-- 产品数据内容 -->
        <div v-else>
          <!-- 桌面端表格视图 -->
          <div class="hidden sm:block relative">
            <div class="flex overflow-hidden" ref="tableContainer">
              <!-- 左侧滚动区域：主要数据列 -->
              <div 
                class="flex-1 overflow-x-auto table-container" 
                ref="leftTableContainer"
              >
                <table class="w-full table-auto min-w-max">
                  <thead class="bg-gray-50">
                    <tr>
                      <th 
                        v-for="fieldConfig in visibleDataFieldConfigs" 
                        :key="`header-${fieldConfig.field_name}`"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider h-[52px]"
                        :style="{ width: fieldConfig.column_width ? `${fieldConfig.column_width}px` : 'auto' }"
                      >
                        {{ fieldConfig.field_label }}
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="product in products" :key="`data-${product.id}`" class="hover:bg-gray-50 group" style="height: 72px;">
                      <td 
                        v-for="fieldConfig in visibleDataFieldConfigs" 
                        :key="`data-${product.id}-${fieldConfig.field_name}`"
                        class="px-6 py-4 text-sm text-gray-500 align-middle"
                        :style="{ 
                          height: '72px', 
                          verticalAlign: 'middle',
                          width: fieldConfig.column_width ? `${fieldConfig.column_width}px` : 'auto'
                        }"
                      >
                  <!-- 特殊字段渲染 -->
                  <template v-if="fieldConfig.field_name === 'image'">
                    <img 
                      :src="getSystemFieldValue(product, 'image')" 
                    :alt="product.name"
                    class="h-10 w-10 min-h-[40px] min-w-[40px] rounded-lg object-cover border border-gray-200 flex-shrink-0"
                    @error="$event.target.src = generatePlaceholderImage(product.name, 40, 40)"
                  >
                  </template>
                  
                  <template v-else-if="fieldConfig.field_name === 'name'">
                  <div class="flex items-center h-10" style="max-height: 40px;">
                      <span class="text-gray-900 font-medium truncate flex-1">{{ product.name }}</span>
                    <span v-if="!product.is_active" class="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800 flex-shrink-0">
                      已禁用
                    </span>
                  </div>
                  </template>
                  
                  <template v-else-if="fieldConfig.field_name === 'group'">
                    <div class="flex items-center h-10" style="max-height: 40px;">
                      <span
                        v-if="product.group_info"
                        class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium truncate"
                        :style="{ backgroundColor: product.group_info.color + '20', color: product.group_info.color }"
                      >
                        {{ product.group_info.name }}
                      </span>
                      <span v-else class="text-gray-400">未分组</span>
                    </div>
                  </template>
                  
                  <template v-else-if="fieldConfig.field_name === 'is_active'">
                    <div class="flex items-center h-10" style="max-height: 40px;">
                      <span 
                        :class="[
                          'inline-flex items-center px-2 py-1 rounded-full text-xs font-medium',
                          product.is_active 
                            ? 'bg-green-100 text-green-800' 
                            : 'bg-gray-100 text-gray-800'
                        ]"
                      >
                        {{ product.is_active ? '启用' : '禁用' }}
                      </span>
                    </div>
                  </template>
                  
                  <template v-else-if="false">
                  <div class="flex items-center justify-start space-x-2">
                    <!-- 状态切换 -->
                    <button
                      @click="handleToggleStatus(product)"
                      :class="[
                        'inline-flex items-center px-2 py-1 rounded text-xs transition-colors',
                        product.is_active 
                          ? 'text-orange-600 hover:text-orange-900 bg-orange-50 hover:bg-orange-100' 
                          : 'text-green-600 hover:text-green-900 bg-green-50 hover:bg-green-100'
                      ]"
                      :title="product.is_active ? '禁用产品' : '启用产品'"
                    >
                      <svg v-if="product.is_active" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728" />
                      </svg>
                      <svg v-else class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      {{ product.is_active ? '禁用' : '启用' }}
                    </button>
                    
                    <!-- 编辑 -->
                    <button
                      @click="handleEditProduct(product)"
                      class="inline-flex items-center text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded text-xs transition-colors"
                      title="编辑产品"
                    >
                      <PencilIcon class="h-4 w-4 mr-1" />
                      编辑
                    </button>
                    
                    <!-- 删除 -->
                    <button
                      @click="handleDeleteProduct(product)"
                      :disabled="product.deleting"
                      class="inline-flex items-center text-red-600 hover:text-red-900 bg-red-50 hover:bg-red-100 px-2 py-1 rounded text-xs transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      title="删除产品"
                    >
                      <TrashIcon v-if="!product.deleting" class="h-4 w-4 mr-1" />
                      <svg v-else class="animate-spin h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      {{ product.deleting ? '删除中...' : '删除' }}
                    </button>
                  </div>
                  </template>
                  
                  <template v-else>
                    <!-- 通用字段显示 -->
                    <div 
                      class="w-full overflow-hidden"
                      :title="getFieldDisplayValue(product, fieldConfig)"
                      style="line-height: 1.2; max-height: 40px; display: flex; align-items: center;"
                    >
                      <span 
                        :class="[
                          'block truncate',
                          'w-full'
                        ]"
                        style="white-space: nowrap;"
                      >
                        {{ getFieldDisplayValue(product, fieldConfig) }}
                      </span>
                    </div>
                  </template>
                </td>
              </tr>
                  </tbody>
                </table>
              </div>

              <!-- 右侧固定列：操作 -->
              <div 
                v-if="actionFieldConfig && actionFieldConfig.is_visible"
                class="flex-shrink-0 bg-gray-50"
                :style="{ width: `${actionColumnWidth}px` }"
                ref="rightTableContainer"
              >
                <table class="w-full" :style="{ width: `${actionColumnWidth}px` }">
                  <thead class="bg-gray-100">
                    <tr>
                      <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider h-[52px]">
                        {{ actionFieldConfig.field_label }}
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-gray-50 divide-y divide-gray-200">
                    <tr v-for="product in products" :key="`action-${product.id}`" class="hover:bg-gray-100 group" style="height: 72px;">
                      <td class="px-6 py-4 text-sm text-gray-500 group-hover:bg-gray-100 transition-colors align-middle" style="height: 72px; vertical-align: middle;">
                        <div class="flex items-center justify-start space-x-2 h-10" style="max-height: 40px;">
                          <!-- 状态切换 -->
                          <button
                            @click="handleToggleStatus(product)"
                            :class="[
                              'inline-flex items-center px-2 py-1 rounded text-xs transition-colors',
                              product.is_active 
                                ? 'text-orange-600 hover:text-orange-900 bg-orange-50 hover:bg-orange-100' 
                                : 'text-green-600 hover:text-green-900 bg-green-50 hover:bg-green-100'
                            ]"
                            :title="product.is_active ? '禁用产品' : '启用产品'"
                          >
                            <svg v-if="product.is_active" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728" />
                            </svg>
                            <svg v-else class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            {{ product.is_active ? '禁用' : '启用' }}
                          </button>
                          
                          <!-- 编辑 -->
                          <button
                            @click="handleEditProduct(product)"
                            class="inline-flex items-center text-blue-600 hover:text-blue-900 bg-blue-50 hover:bg-blue-100 px-2 py-1 rounded text-xs transition-colors"
                            title="编辑产品"
                          >
                            <PencilIcon class="h-4 w-4 mr-1" />
                            编辑
                          </button>
                          
                          <!-- 删除 -->
                          <button
                            @click="handleDeleteProduct(product)"
                            :disabled="product.deleting"
                            class="inline-flex items-center text-red-600 hover:text-red-900 bg-red-50 hover:bg-red-100 px-2 py-1 rounded text-xs transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                            title="删除产品"
                          >
                            <TrashIcon v-if="!product.deleting" class="h-4 w-4 mr-1" />
                            <svg v-else class="animate-spin h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 818-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 714 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            {{ product.deleting ? '删除中...' : '删除' }}
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- 手机端卡片视图 -->
          <div class="block sm:hidden space-y-4">
            <!-- 产品卡片列表 -->
            <div
              v-for="product in products"
              :key="product.id"
              class="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
            >
              <!-- 卡片头部 -->
              <div class="p-4 border-b border-gray-100">
                <div class="flex items-start justify-between">
                  <div class="flex items-start space-x-3 flex-1">
                    <!-- 产品图片 -->
                    <img 
                      :src="getSystemFieldValue(product, 'image')" 
                      :alt="product.name"
                      class="h-12 w-12 min-h-[48px] min-w-[48px] rounded-lg object-cover border border-gray-200 flex-shrink-0"
                      @error="$event.target.src = generatePlaceholderImage(product.name, 48, 48)"
                    >
                    <!-- 产品基本信息 -->
                    <div class="flex-1 min-w-0">
                      <h3 class="text-base font-medium text-gray-900 truncate">
                        {{ product.name }}
                      </h3>
                      <p class="text-sm text-gray-500 truncate">{{ product.code }}</p>
                      <div class="flex flex-wrap gap-2 mt-2">
                        <span v-if="product.brand" class="inline-flex items-center text-xs text-gray-600">
                          🏷️ {{ product.brand }}
                        </span>
                        <span 
                          :class="[
                            'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium',
                            product.is_active 
                              ? 'bg-green-100 text-green-800' 
                              : 'bg-gray-100 text-gray-800'
                          ]"
                        >
                          {{ product.is_active ? '启用' : '禁用' }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- 时间 -->
                  <div class="text-xs text-gray-400 ml-2">
                    {{ formatDate(product.created_at).split(' ')[0] }}
                  </div>
                </div>
              </div>

              <!-- 卡片内容 -->
              <div class="p-4 space-y-3">
                <!-- 产品描述 -->
                <div v-if="product.description" class="flex items-start space-x-2">
                  <span class="text-xs font-medium text-gray-500 mt-0.5">描述:</span>
                  <span class="text-sm text-gray-900 flex-1 leading-relaxed">{{ product.description }}</span>
                </div>

                <!-- 分组 -->
                <div v-if="product.group_info">
                  <div class="flex items-center space-x-2 mb-2">
                    <span class="text-xs font-medium text-gray-500">分组:</span>
                  </div>
                  <span
                    class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
                    :style="{ backgroundColor: product.group_info.color + '20', color: product.group_info.color }"
                  >
                    {{ product.group_info.name }}
                  </span>
                </div>

                <!-- 自定义字段显示 -->
                <div v-if="product.custom_fields && Object.keys(product.custom_fields).length > 0">
                  <div class="space-y-2">
                    <div v-for="(fieldData, fieldName) in product.custom_fields" :key="fieldName" class="flex items-start space-x-2">
                      <span class="text-xs font-medium text-gray-500 mt-0.5">{{ fieldData.label }}:</span>
                      <span class="text-sm text-gray-900 flex-1 leading-relaxed">{{ getCustomFieldValue(product, fieldName) }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 卡片底部操作 -->
              <div class="px-4 py-3 bg-gray-50 border-t border-gray-100 rounded-b-lg">
                <div class="flex items-center justify-between space-x-2">
                  <div class="flex items-center space-x-2">
                    <!-- 状态切换 -->
                    <button
                      @click="handleToggleStatus(product)"
                      :class="[
                        'inline-flex items-center px-3 py-2 rounded-md text-xs font-medium transition-colors border',
                        product.is_active 
                          ? 'text-orange-600 hover:text-orange-900 bg-orange-50 hover:bg-orange-100 border-orange-200' 
                          : 'text-green-600 hover:text-green-900 bg-green-50 hover:bg-green-100 border-green-200'
                      ]"
                      :title="product.is_active ? '禁用产品' : '启用产品'"
                    >
                      <svg v-if="product.is_active" class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728" />
                      </svg>
                      <svg v-else class="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      {{ product.is_active ? '禁用' : '启用' }}
                    </button>

                    <!-- 编辑 -->
                    <button
                      @click="handleEditProduct(product)"
                      class="inline-flex items-center text-gray-600 hover:text-gray-900 bg-white hover:bg-gray-50 px-3 py-2 rounded-md text-xs font-medium transition-colors border border-gray-200"
                      title="编辑产品"
                    >
                      <PencilIcon class="h-4 w-4 mr-1" />
                      编辑
                    </button>
                  </div>

                  <!-- 删除按钮 -->
                  <button
                    @click="handleDeleteProduct(product)"
                    :disabled="product.deleting"
                    class="inline-flex items-center text-red-600 hover:text-red-900 bg-red-50 hover:bg-red-100 px-3 py-2 rounded-md text-xs font-medium transition-colors border border-red-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    title="删除产品"
                  >
                    <TrashIcon v-if="!product.deleting" class="h-4 w-4 mr-1" />
                    <svg v-else class="animate-spin h-4 w-4 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 714 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {{ product.deleting ? '删除中...' : '删除' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div v-if="products.length > 0" class="bg-white border-t border-gray-200 rounded-b-lg shadow-sm">
          <!-- 移动端分页：分页按钮和每页数量选择器 -->
          <div class="px-4 py-3 sm:hidden">
            <div class="flex justify-between items-center">
              <button
                @click="prevPage"
                :disabled="currentPage === 1 || loading"
                class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
              >
                上一页
              </button>
              
              <!-- 每页数量选择器 -->
              <div class="flex items-center space-x-2">
                <span class="text-sm text-gray-700">每页</span>
                <select
                  v-model="pageSize"
                  @change="handlePageSizeChange"
                  class="border border-gray-300 rounded-md px-3 py-1 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent min-w-[60px] w-auto"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="text-sm text-gray-700">条</span>
              </div>
              
              <button
                @click="nextPage"
                :disabled="currentPage === totalPages || loading"
                class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50"
              >
                下一页
              </button>
            </div>
          </div>
          
          <!-- 桌面端分页：显示完整信息 -->
          <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between px-6 py-3">
            <div class="flex items-center space-x-4">
              <span class="text-sm text-gray-700">
                显示第 {{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, totalProducts) }} 条，
                共 {{ totalProducts }} 条记录
              </span>
              
              <!-- 每页数量选择器 -->
              <div class="flex items-center space-x-2">
                <span class="text-sm text-gray-700">每页</span>
                <select
                  v-model="pageSize"
                  @change="handlePageSizeChange"
                  class="border border-gray-300 rounded-md px-3 py-1 pr-8 text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent min-w-[60px] w-auto"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="text-sm text-gray-700">条</span>
              </div>
            </div>
            <div class="flex items-center space-x-2">
              <button
                @click="prevPage"
                :disabled="currentPage === 1 || loading"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <ChevronLeftIcon class="h-4 w-4" />
                上一页
              </button>
              <span class="px-3 py-2 text-sm font-medium text-gray-700">
                第 {{ currentPage }} / {{ totalPages }} 页
              </span>
              <button
                @click="nextPage"
                :disabled="currentPage === totalPages || loading"
                class="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                下一页
                <ChevronRightIcon class="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品添加/编辑模态框 -->
    <ProductModal 
      :show="showProductModal"
      :product="editingProduct"
      :custom-fields-update-trigger="customFieldsUpdateTrigger"
      @close="closeProductModal"
      @success="handleProductModalSuccess"
    />

    <!-- 分组管理模态框 -->
    <ProductGroupManagementModal
      :show="showGroupManagementModal"
      @close="closeGroupManagementModal"
      @success="handleGroupManagementSuccess"
    />

    <!-- 自定义字段管理模态框 -->
    <ProductCustomFieldManagementModal
      :show="showCustomFieldManagementModal"
      @close="closeCustomFieldManagementModal"
      @success="handleCustomFieldManagementSuccess"
    />

    <!-- 字段配置管理模态框 -->
    <ProductFieldConfigModal
      :show="showFieldConfigModal"
      @close="closeFieldConfigModal"
      @success="handleFieldConfigSuccess"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { 
  MagnifyingGlassIcon, 
  PlusIcon, 
  PencilIcon, 
  TrashIcon, 
  ChevronLeftIcon,
  ChevronRightIcon
} from '@heroicons/vue/24/outline'
import { useToast } from 'vue-toastification'
import { useAuthStore } from '@/stores/auth'
import productService, { productCustomFieldService, productFieldConfigService } from '@/services/productService'
import ProductModal from '@/components/products/ProductModal.vue'
import ProductGroupManagementModal from '@/components/products/ProductGroupManagementModal.vue'
import ProductCustomFieldManagementModal from '@/components/products/ProductCustomFieldManagementModal.vue'
import ProductFieldConfigModal from '@/components/products/ProductFieldConfigModal.vue'
import SearchableSelect from '@/components/common/SearchableSelect.vue'

const toast = useToast()
const authStore = useAuthStore()

// 响应式数据
const searchQuery = ref('')
const currentPage = ref(1)
const pageSize = ref(10)
const products = ref([])
const loading = ref(false)
const totalProducts = ref(0)

// 筛选数据
const selectedGroup = ref('')
const selectedBrand = ref('')
const productGroups = ref([])
const brands = ref([])
const displayCustomFields = ref([])
const fieldConfigs = ref([]) // 字段配置

// API状态
const apiError = ref('')

// 数据加载状态管理
const loadingStates = ref({
  productGroups: false,
  brands: false,
  displayCustomFields: false,
  fieldConfigs: false
})

// 数据是否已加载过的标记
const dataLoaded = ref({
  productGroups: false,
  brands: false,
  displayCustomFields: false,
  fieldConfigs: false
})

// 模态框状态
const showProductModal = ref(false)
const editingProduct = ref(null)
const showGroupManagementModal = ref(false)
const showCustomFieldManagementModal = ref(false)
const showFieldConfigModal = ref(false)

// 自定义字段更新触发器
const customFieldsUpdateTrigger = ref(0)

// 账号类型判断
const isSubAccount = computed(() => {
  return authStore.user?.account_type === 'sub'
})

// 🔧 子账号不能管理（创建/编辑/删除）自定义字段
const canManageCustomFields = computed(() => {
  return !isSubAccount.value
})

// 计算属性
const totalPages = computed(() => Math.ceil(totalProducts.value / pageSize.value))

const hasActiveFilters = computed(() => {
  return selectedGroup.value || selectedBrand.value
})

// 分组选项（用于SearchableSelect）
const groupOptions = computed(() => {
  return productGroups.value.map(group => ({
    id: group.id,
    name: `${group.name} (${group.product_count})`
  }))
})

// 品牌选项（用于SearchableSelect）
const brandOptions = computed(() => {
  return brands.value.map(brand => ({
    id: brand,
    name: brand
  }))
})

// 可见字段配置（按排序顺序）
const visibleFieldConfigs = computed(() => {
  return fieldConfigs.value
    .filter(config => config.is_visible)
    .sort((a, b) => a.sort_order - b.sort_order)
})

// 可见数据字段（除了操作列）
const visibleDataFieldConfigs = computed(() => {
  return visibleFieldConfigs.value.filter(config => config.field_name !== 'actions')
})

// 操作字段配置
const actionFieldConfig = computed(() => {
  return visibleFieldConfigs.value.find(config => config.field_name === 'actions')
})

// 操作列宽度
const actionColumnWidth = computed(() => {
  return actionFieldConfig.value?.column_width || 255
})

// 采用与客户管理一致的列宽配置方式：直接使用字段配置的column_width像素值
// 优势：简单直接，所见即所得，与后端配置完全一致
// 当前默认字段宽度配置：
// 图片: 80px, 产品名称: 200px, 产品编号: 180px
// 品牌: 120px, 分组: 120px, 产品描述: 220px
// 创建者: 200px, 创建时间: 200px
// 操作列: 255px（固定在右侧）

// 生成占位图片
const generatePlaceholderImage = (text, width = 40, height = 40) => {
  // 安全处理文本：取第1个字符，如果为空则使用默认文字
  const safeText = (text || '产').slice(0, 1)
  // HTML实体编码，防止特殊字符问题
  const encodedText = safeText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  
  const svg = `
    <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
      <rect width="100%" height="100%" fill="#f3f4f6"/>
      <text x="50%" y="50%" font-family="Arial, sans-serif" font-size="16" font-weight="500" fill="#6b7280" text-anchor="middle" dominant-baseline="middle">
        ${encodedText}
      </text>
    </svg>
  `
  return `data:image/svg+xml;base64,${btoa(unescape(encodeURIComponent(svg)))}`
}

// 处理搜索
const handleSearch = () => {
  // 立即滚动到顶部
  window.scrollTo({
    top: 0,
    behavior: 'instant'
  })
  // 然后执行搜索
  searchProducts(true)
}

// 搜索产品
const searchProducts = async (resetPage = true) => {
  if (resetPage) {
    currentPage.value = 1
  }
  
  loading.value = true
  apiError.value = ''
  
  try {
    const params = {
      page: currentPage.value,
      page_size: pageSize.value,
      ordering: '-created_at'
    }
    
    // 添加搜索关键词
    if (searchQuery.value.trim()) {
      params.search = searchQuery.value.trim()
    }
    
    // 添加筛选条件
    if (selectedGroup.value) {
      params.group = selectedGroup.value
    }
    
    if (selectedBrand.value) {
      params.brand = selectedBrand.value
    }
    
    const response = await productService.getProducts(params)
    
    if (response.success) {
      // 更新产品列表
      products.value = response.results.map(product => ({
        ...product,
        deleting: false, // 添加删除状态
        image: product.image_url || generatePlaceholderImage(product.name, 40, 40),
        sku: product.code // 映射code为sku
      }))
      
      totalProducts.value = response.count
      
      // 显示搜索结果信息
      if (searchQuery.value.trim()) {
        toast.info(`找到 ${response.count} 个相关产品`)
      }
    } else {
      toast.error('获取产品列表失败')
    }
    
  } catch (error) {
    console.error('搜索产品失败:', error)
    apiError.value = error.response?.data?.message || error.message || '获取产品列表失败'
    
    if (error.response?.status === 401) {
      toast.error('请先登录')
    } else if (error.response?.status === 403) {
      toast.error('没有权限访问产品列表')
    } else {
      toast.error(apiError.value)
    }
    
    // 清空列表
    products.value = []
    totalProducts.value = 0
  } finally {
    loading.value = false
  }
}

// 分页方法
const prevPage = async () => {
  if (currentPage.value > 1) {
    // 立即滚动到顶部
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    })
    
    currentPage.value--
    await searchProducts(false)
  }
}

const nextPage = async () => {
  if (currentPage.value < totalPages.value) {
    // 立即滚动到顶部
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    })
    
    currentPage.value++
    await searchProducts(false)
  }
}

// 处理每页数量变化
const handlePageSizeChange = async () => {
  // 确保 pageSize 是数字类型
  pageSize.value = Number(pageSize.value)
  
  // 滚动到顶部
  window.scrollTo({
    top: 0,
    behavior: 'instant'
  })
  
  // 重置到第一页
  currentPage.value = 1
  
  // 重新加载数据
  await searchProducts(false)
}

const goToPage = async (page) => {
  if (page >= 1 && page <= totalPages.value) {
    // 立即滚动到顶部
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    })
    
    currentPage.value = page
    await searchProducts(false)
  }
}

// 格式化日期
const formatDate = (dateString) => {
  const date = new Date(dateString)
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  })
}

// 添加产品
const handleAddProduct = () => {
  editingProduct.value = null
  showProductModal.value = true
}

// 编辑产品
const handleEditProduct = (product) => {
  editingProduct.value = product
  showProductModal.value = true
}

// 分组管理
const handleManageGroups = () => {
  showGroupManagementModal.value = true
}

// 自定义字段管理
const handleManageCustomFields = () => {
  showCustomFieldManagementModal.value = true
}

// 字段配置管理
const handleFieldConfig = () => {
  showFieldConfigModal.value = true
}

// 关闭模态框
const closeProductModal = () => {
  showProductModal.value = false
  editingProduct.value = null
}

const closeGroupManagementModal = () => {
  showGroupManagementModal.value = false
}

const closeCustomFieldManagementModal = () => {
  showCustomFieldManagementModal.value = false
}

const closeFieldConfigModal = () => {
  showFieldConfigModal.value = false
}

// 模态框成功回调
const handleProductModalSuccess = async (productData) => {
  
  try {
    if (editingProduct.value) {
      // 编辑模式：更新列表中的产品
      const index = products.value.findIndex(p => p.id === editingProduct.value.id)
      if (index > -1) {
        products.value[index] = {
          ...productData,
          deleting: false,
          image: productData.image_url || generatePlaceholderImage(productData.name, 40, 40),
          sku: productData.code
        }
      }
    } else {
      // 新增模式：刷新列表（因为可能涉及分页）
      await searchProducts(false)
    }
  } catch (error) {
    console.error('Error in handleProductModalSuccess:', error)
  }
}

const handleGroupManagementSuccess = () => {
  // 分组管理成功后，强制重新加载分组列表（因为分组可能有变化）
  loadProductGroups(true)
  // 重新加载产品列表以更新分组信息
  searchProducts(false)
}

const handleCustomFieldManagementSuccess = () => {
  // 自定义字段管理成功后，强制重新加载自定义字段（因为字段可能有变化）
  loadDisplayCustomFields(true)
  // 强制重新加载字段配置以更新列表布局（自定义字段变化会影响配置）
  loadFieldConfigs(true)
  // 重新加载产品列表以更新自定义字段显示
  searchProducts(false)
  // 触发产品模态框中的自定义字段重新加载
  customFieldsUpdateTrigger.value++
}

const handleFieldConfigSuccess = () => {
  // 字段配置更新后，强制重新加载字段配置（因为配置已变化）
  loadFieldConfigs(true)
  // 重新加载产品列表以应用新的字段配置
  searchProducts(false)
}


// 切换产品状态
const handleToggleStatus = async (product) => {
  const originalStatus = product.is_active
  const action = originalStatus ? '禁用' : '启用'
  
  try {
    // 乐观更新
    product.is_active = !originalStatus
    
    const response = await productService.toggleProductStatus(product.id)
    
    if (response.success) {
      product.is_active = response.data.is_active
      toast.success(response.message || `产品已${action}`)
    } else {
      // 回滚状态
      product.is_active = originalStatus
      toast.error(`${action}失败`)
    }
  } catch (error) {
    // 回滚状态
    product.is_active = originalStatus
    console.error(`${action}产品失败:`, error)
    
    const errorMsg = error.response?.data?.message || error.message || `${action}失败`
    toast.error(errorMsg)
  }
}

// 删除产品
const handleDeleteProduct = async (product) => {
  if (confirm(`确定要删除产品 ${product.name} 吗？此操作不可撤销。`)) {
    product.deleting = true
    
    try {
      const response = await productService.deleteProduct(product.id)
      
      if (response.success) {
        // 直接从前端数组中移除被删除的产品
        const index = products.value.findIndex(p => p.id === product.id)
        if (index > -1) {
          products.value.splice(index, 1)
          // 更新总数
          totalProducts.value = Math.max(0, totalProducts.value - 1)
        }
        
        toast.success(`产品 ${product.name} 已删除`)
        
        // 如果当前页没有数据了，且不是第一页，则跳转到上一页
        if (products.value.length === 0 && currentPage.value > 1) {
          currentPage.value--
          await searchProducts(false)
        }
      }
    } catch (error) {
      console.error('删除产品失败:', error)
      
      if (error.response?.status === 403) {
        toast.error('没有权限删除此产品')
      } else if (error.response?.status === 404) {
        toast.error('产品不存在或已被删除')
        // 刷新列表
        await searchProducts(false)
      } else {
        const errorMsg = error.response?.data?.message || error.message || '删除失败'
        toast.error(`删除产品失败: ${errorMsg}`)
      }
    } finally {
      product.deleting = false
    }
  }
}

// 清空筛选
const clearFilters = () => {
  selectedGroup.value = ''
  selectedBrand.value = ''
  searchQuery.value = ''
  handleSearch()
}

// 加载产品分组数据
const loadProductGroups = async (forceReload = false) => {
  // 如果已经在加载中，直接返回
  if (loadingStates.value.productGroups) {
    return
  }
  
  // 如果已经加载过且不强制重新加载，直接返回
  if (dataLoaded.value.productGroups && !forceReload) {
    return
  }
  
  loadingStates.value.productGroups = true
  
  try {
    const response = await productService.getGroups()
    if (response.success) {
      productGroups.value = response.data
      dataLoaded.value.productGroups = true
    }
  } catch (error) {
    console.error('加载产品分组失败:', error)
  } finally {
    loadingStates.value.productGroups = false
  }
}

// 加载品牌数据
const loadBrands = async (forceReload = false) => {
  // 如果已经在加载中，直接返回
  if (loadingStates.value.brands) {
    return
  }
  
  // 如果已经加载过且不强制重新加载，直接返回
  if (dataLoaded.value.brands && !forceReload) {
    return
  }
  
  loadingStates.value.brands = true
  
  try {
    const response = await productService.getBrands()
    if (response.success) {
      brands.value = response.data
      dataLoaded.value.brands = true
    }
  } catch (error) {
    console.error('加载品牌列表失败:', error)
  } finally {
    loadingStates.value.brands = false
  }
}

// 加载在列表显示的自定义字段
const loadDisplayCustomFields = async (forceReload = false) => {
  // 如果已经在加载中，直接返回
  if (loadingStates.value.displayCustomFields) {
    return
  }
  
  // 如果已经加载过且不强制重新加载，直接返回
  if (dataLoaded.value.displayCustomFields && !forceReload) {
    return
  }
  
  loadingStates.value.displayCustomFields = true
  
  try {
    const response = await productCustomFieldService.getCustomFields({
      is_active: true,
      is_list_display: true,
      page_size: 100
    })
    if (response.success) {
      displayCustomFields.value = response.results || []
      dataLoaded.value.displayCustomFields = true
    }
  } catch (error) {
    console.error('加载自定义字段失败:', error)
  } finally {
    loadingStates.value.displayCustomFields = false
  }
}

// 加载字段配置
const loadFieldConfigs = async (forceReload = false) => {
  // 如果已经在加载中，直接返回
  if (loadingStates.value.fieldConfigs) {
    return
  }
  
  // 如果已经加载过且不强制重新加载，直接返回
  if (dataLoaded.value.fieldConfigs && !forceReload) {
    return
  }
  
  loadingStates.value.fieldConfigs = true
  
  try {
    const response = await productFieldConfigService.getVisibleFieldConfigs()
    if (response.success) {
      fieldConfigs.value = response.data || []
      dataLoaded.value.fieldConfigs = true
    }
  } catch (error) {
    console.error('加载字段配置失败:', error)
    // 如果加载失败，初始化默认配置
    try {
      await productFieldConfigService.initializeFieldConfigs()
      const retryResponse = await productFieldConfigService.getVisibleFieldConfigs()
      if (retryResponse.success) {
        fieldConfigs.value = retryResponse.data || []
        dataLoaded.value.fieldConfigs = true
      }
    } catch (initError) {
      console.error('初始化字段配置失败:', initError)
    }
  } finally {
    loadingStates.value.fieldConfigs = false
  }
}

// 获取字段显示值的通用方法
const getFieldDisplayValue = (product, fieldConfig) => {
  if (fieldConfig.field_type === 'system') {
    return getSystemFieldValue(product, fieldConfig.field_name)
  } else if (fieldConfig.field_type === 'custom') {
    return getCustomFieldValue(product, fieldConfig.custom_field_info)
  }
  return '-'
}

// 获取系统字段值
const getSystemFieldValue = (product, fieldName) => {
  switch (fieldName) {
    case 'image':
      return product.image || generatePlaceholderImage(product.name, 40, 40)
    case 'name':
      return product.name
    case 'code':
      return product.sku || product.code
    case 'brand':
      return product.brand || '-'
    case 'group':
      return product.group_info ? product.group_info.name : '未分组'
    case 'description':
      return product.description || '-'
    case 'creator':
      return product.creator || '-'
    case 'created_at':
      return formatDate(product.created_at)
    case 'is_active':
      return product.is_active ? '启用' : '禁用'
    case 'actions':
      return 'actions' // 特殊标记，用于渲染操作按钮
    default:
      return '-'
  }
}

// 获取自定义字段值
const getCustomFieldValue = (product, customFieldInfo) => {
  if (!product.custom_fields || !customFieldInfo) {
    return '-'
  }
  
  const fieldValue = product.custom_fields[customFieldInfo.name]
  if (!fieldValue) {
    return '-'
  }
  
  return getCustomFieldDisplayValue(product, customFieldInfo)
}

// 获取自定义字段的显示值
const getCustomFieldDisplayValue = (product, field) => {
  if (!product.custom_fields || !product.custom_fields[field.name]) {
    return '-'
  }
  
  const fieldValue = product.custom_fields[field.name].value
  
  // 根据字段类型格式化值
  switch (field.field_type) {
    case 'boolean':
      return fieldValue ? '是' : '否'
    case 'choice':
      if (field.choices && Array.isArray(field.choices)) {
        const choice = field.choices.find(c => c.value === fieldValue)
        return choice ? choice.label : fieldValue
      }
      return fieldValue
    case 'multiple_choice':
      if (Array.isArray(fieldValue) && field.choices) {
        const labels = fieldValue.map(value => {
          const choice = field.choices.find(c => c.value === value)
          return choice ? choice.label : value
        })
        return labels.join(', ')
      }
      return Array.isArray(fieldValue) ? fieldValue.join(', ') : fieldValue
    case 'date':
      if (fieldValue) {
        return new Date(fieldValue).toLocaleDateString('zh-CN')
      }
      return fieldValue
    case 'datetime':
      if (fieldValue) {
        return new Date(fieldValue).toLocaleString('zh-CN')
      }
      return fieldValue
    default:
      return fieldValue || '-'
  }
}

// 加载初始数据（并行加载以提高性能）
const loadInitialData = async () => {
  try {
    // 并行加载所有基础数据，提高加载速度
    await Promise.all([
      searchProducts(),
      loadProductGroups(),
      loadBrands(),
      loadDisplayCustomFields(),
      loadFieldConfigs()
    ])
  } catch (error) {
    console.error('加载初始数据失败:', error)
  }
}

// 组件挂载时加载数据
onMounted(() => {
  loadInitialData()
})
</script>

<style scoped>
/* 美化表格容器的水平滚动条 */
.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f8fafc;
  border-radius: 4px;
  margin: 0 4px;
}

.table-container::-webkit-scrollbar-thumb {
  background: linear-gradient(90deg, #e2e8f0, #cbd5e1);
  border-radius: 4px;
  transition: all 0.3s ease;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(90deg, #cbd5e1, #94a3b8);
  transform: scaleY(1.2);
}

/* Firefox 滚动条样式 */
.table-container {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f8fafc;
}

/* 表格文本处理 */
.table-container td {
  word-break: normal;
  overflow-wrap: normal;
}
</style>